"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getHeaderMarkdown = exports.getHeaderDescription = exports.getHeaderLink = exports.isHeaderDeprecated = exports.isHeaderExperimental = exports.isHeaderValid = exports.normalizeHeader = void 0;
var http_headers_1 = require("./http-headers");
/**
 * Converts potentially non-compliant string into HTTP header type
 */
var normalizeHeader = function (header) {
    return header
        .toLowerCase()
        .split('-')
        .map(function (h) { return h.charAt(0).toUpperCase() + h.slice(1); })
        .join('-');
};
exports.normalizeHeader = normalizeHeader;
/**
 * Is header documented via MDN's https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers
 */
var isHeaderValid = function (header) {
    var normalizedHeader = (0, exports.normalizeHeader)(header);
    return !!http_headers_1.default[normalizedHeader];
};
exports.isHeaderValid = isHeaderValid;
/**
 * Returns if header is flagged as `experimental`.
 */
var isHeaderExperimental = function (header) {
    var _a;
    var normalizedHeader = (0, exports.normalizeHeader)(header);
    return !!((_a = http_headers_1.default[normalizedHeader]) === null || _a === void 0 ? void 0 : _a.experimental);
};
exports.isHeaderExperimental = isHeaderExperimental;
/**
 * Returns if header is flagged as `deprecated`.
 */
var isHeaderDeprecated = function (header) {
    var _a;
    var normalizedHeader = (0, exports.normalizeHeader)(header);
    return !!((_a = http_headers_1.default[normalizedHeader]) === null || _a === void 0 ? void 0 : _a.deprecated);
};
exports.isHeaderDeprecated = isHeaderDeprecated;
/**
 * Returns direct link to header's unique page in MDN.
 * @example
 * getHeaderLink('Accept') -> 'https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Accept'
 */
var getHeaderLink = function (header) {
    var _a;
    var normalizedHeader = (0, exports.normalizeHeader)(header);
    return ((_a = http_headers_1.default[normalizedHeader]) === null || _a === void 0 ? void 0 : _a.link) || '';
};
exports.getHeaderLink = getHeaderLink;
/**
 * Returns header description, as documented in MDN.
 * @example
 * getHeaderDescription('Authorization') => 'Contains the credentials to authenticate a user-agent with a server.
 */
var getHeaderDescription = function (header) {
    var _a;
    var normalizedHeader = (0, exports.normalizeHeader)(header);
    return ((_a = http_headers_1.default[normalizedHeader]) === null || _a === void 0 ? void 0 : _a.description) || '';
};
exports.getHeaderDescription = getHeaderDescription;
/**
 * Returns header description, formatted in markdown.
 */
var getHeaderMarkdown = function (header) {
    var _a, _b;
    var normalizedHeader = (0, exports.normalizeHeader)(header);
    return ((_a = http_headers_1.default[normalizedHeader]) === null || _a === void 0 ? void 0 : _a.markdown) || ((_b = http_headers_1.default[normalizedHeader]) === null || _b === void 0 ? void 0 : _b.description) || '';
};
exports.getHeaderMarkdown = getHeaderMarkdown;
/**
 * Performs lookup of an HTTP Header in MDN's snapshotted documentation.
 * Sourced from https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers.
 */
function getHeader(header) {
    var _a;
    var normalizedHeader = (0, exports.normalizeHeader)(header);
    return (_a = http_headers_1.default[normalizedHeader]) !== null && _a !== void 0 ? _a : {};
}
exports.default = getHeader;
